<template>
  <div id="dealPursuitsTable" style="max-height: 500px">
    <a-modal :visible="showTable"  @cancel="showTable = false" :footer="null"  width="800px" class="my-ant-modal">
      <div class="content">
        <a-row>
          <div style="font-size: 16px;color: #333333;display: flex; align-items: center;margin-top:10px;margin-bottom:30px;">
            <pt-icon type="icon-tishi" :styleObj="{fontSize:'25px',marginRight:'11px'}"></pt-icon>
            {{$t('deal.addDeal.dealPursuitsVO.tips')}}
          </div>
        </a-row>
        <a-row>
          <el-table :data="dealPursuitsList"  row-class-name="tableRowClassName" header-row-class-name="tableRowClassName">
              <el-table-column :label="$t('deal.dealPursuitsTable.tableHeader.type')" align="center">
                <template slot-scope="scope">
                  <span v-text="scope.row.type == 1 ? $t('customer.customerDetail.deal'):$t('customer.customerDetail.pursuits')"></span>
                </template>
              </el-table-column>
            <el-table-column :label="$t('deal.dealPursuitsTable.tableHeader.dealType')"  class-name="type_icon" width="150" align="left" show-overflow-tooltip>
              <template slot-scope="scope">
                <template v-if="scope.row.projectType != '~' && scope.row.type == 2">
                  <!--<div class="icon_span" >-->
                    <!--<div :style="selectIcon(scope.row.projectType).style">-->
                      <!--<pt-icon :type="selectIcon(scope.row.projectType).type" style="font-size: 20px;"></pt-icon>-->
                    <!--</div>-->
                  <!--</div>-->
                  <span>{{$t('deal.dealTypes.' + scope.row.projectType)}}</span>
                </template>
                <template v-if="scope.row.projectType != '~' && scope.row.type == 1">
                  <template v-if="scope.row.projectType.split(',').length == 1">
                    <!--<div class="icon_span" >-->
                      <!--<div :style="selectIcon(scope.row.projectType).style">-->
                        <!--<pt-icon :type="selectIcon(scope.row.projectType).type" style="font-size: 20px;"></pt-icon>-->
                      <!--</div>-->
                    <!--</div>-->
                    <span>
                      {{scope.row.projectType}}
                    </span>
                  </template>
                  <template v-else>
                    <!--<div class="icon_span" >-->
                      <!--<div style="background-color: rgb(227, 227, 227)">-->
                        <!--<pt-icon type="icon-duogeleixingtubiao-no"></pt-icon>-->
                      <!--</div>-->
                    <!--</div>-->
                    <span>
                              {{scope.row.projectType}}
                            </span>
                  </template>
                </template>
              </template>
            </el-table-column>
            <el-table-column :label="$t('deal.dealPursuitsTable.tableHeader.projectName')" show-overflow-tooltip align="center">
              <template slot-scope="scope">
                <span>{{scope.row.projectName}}</span>
              </template>
            </el-table-column>
              <el-table-column :label="$t('deal.dealPursuitsTable.tableHeader.projectStages')" show-overflow-tooltip align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.projectStagesStr}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('deal.dealPursuitsTable.tableHeader.latestFollow')" align="center">
                <template slot-scope="scope">
                  <span>{{scope.row.lastFollowDate | dayjs}}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('deal.dealPursuitsTable.tableHeader.accounts')" align="center">
                <template slot-scope="scope">
                  <avatar-list size="small" :max-length="4" :list-length="scope.row.employeeDOList.length">
                    <avatar-list-item :tips="employeeDO.userName" v-for="employeeDO in scope.row.employeeDOList" :key="employeeDO.accountid"
                                      :src="getHelpsImg(employeeDO.headimg)" />
                  </avatar-list>
                </template>
              </el-table-column>
          </el-table>
        </a-row>
        <a-row>
          <div class="table-pagination"  v-show="dealPage.total > 0 &&　dealPage.total > dealPage.size">
            <a-pagination size="small" @change="dealPursuitsTableChange"  :total="dealPage.total" :pageSize="dealPage.size" :hideOnSinglePage="true" :showTotal="dealPage.showTotal" />
          </div>
        </a-row>
      </div>
    </a-modal>
  </div>
</template>

<script>
  import dealApi from '@/api/mine/deal'
  import AvatarList from '../../../components/AvatarList/List'
  import AvatarListItem from '../../../components/AvatarList/Item'

  export default {
    name: 'dealPursuitsTable',
    components:{ AvatarListItem, AvatarList},
    props: {
      pursuitsToDealVO:{
        type:Object,
        default: () => { return null }
      },
    },
    data() {
      return {
        customerId:null,
        customerType:null,
        dealPage:{
          size: 5,
          current: 1,
          total: 1,
          showTotal:(total)=>{
            return `共${total}条`
          }
        },//交易追踪列表分页
        dealPursuitsList:[],//列表数据
        showTable:false,
      }
    },
    mounted() {
    },
    methods: {
      selectIcon(dealType){
        console.log('类型'+dealType);
        return this.$utils.getDealTypeIconNoBackground(dealType);
      },
      queryDealPursuitsList(customerId,customerType){
        let this_ = this
        this.customerId = customerId
        this.customerType = customerType
        dealApi.queryDealPursuitsByCustomerOwnerId({size:this_.dealPage.size,current: this_.dealPage.current},customerId,customerType).then(res=>{
          if(res.code == 1){
            //判断是不是追踪转交易(过滤该追踪)
            this_.dealPursuitsList = res.data.records
            this_.dealPage.total = res.data.total
            if(this.pursuitsToDealVO != null && this_.dealPursuitsList.length > 0){
              for(let i = 0;i < this_.dealPursuitsList.length;i++){
                if(this_.dealPursuitsList[i].type == 2 && this_.dealPursuitsList[i].id == this.pursuitsToDealVO.id){
                  this_.dealPursuitsList.splice(i,1);
                  this_.dealPage.total --;
                  i--;
                }
              }
              if(this_.dealPage.total > 0){
                this_.showTable = true
              }
            }else{
              if(this_.dealPage.total > 0){
                this_.showTable = true
              }
            }
          }
        })
      },
      getHelpsImg(headimg){
        let url = this.$util.getFileUrl(headimg);
        return url;
      },
      dealPursuitsTableChange(page,pageSize){
        this.dealPage.current = page
        this.queryDealPursuitsList(this.customerId,this.customerType);
      },
    }
  }
</script>
<style>
  .my-ant-modal > .ant-modal-content > .ant-modal-body{
    max-height: 470px !important;
  }
</style>
<style scoped lang="less">
  .icon_span{
    display: inline-block;
    margin-right: 5px;
    width: 35px;
    height: 35px;
    text-align: center;
    >div{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 35px;
      border-radius: 50%;
      height: 35px;
    }
  }
/*  /deep/.ant-modal-body{
    max-height: 455px !important;
  }*/
  /deep/.tableRowClassName{
    background: #FAFBFC;
  }
  .table-pagination{
    margin-top: 10px;
    text-align: right;
  }
</style>